<template>
  <div>
    <v-menu transition="slide-y-transition" bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="rv-actions-btn text-light" color="primary" v-bind="attrs" v-on="on">
          Actions
          <v-icon size="18" class="ml-1" color="white">mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list class="rv-actions-menu">
        <v-list-item
          v-for="(item, i) in actionItems"
          :key="i"
          link
          class="rv-actions-menu__item"
          @click="triggerAction(item.clickFunc)"
        >
          <v-icon class="rv-actions-menu__icon">{{ item.icon }}</v-icon> &nbsp;
          <v-list-item-title class="rv-actions-menu__title">{{ item.title }} </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog
      v-model="apApplicationSelectionDialog"
      max-width="600px"
      content-class="rv-selection-dialog"
      @click:outside="toggleSelectionDialog(false)"
    >
      <v-card class="rv-selection-dialog__card">
        <div class="rv-selection-dialog__header">
          <v-icon class="rv-selection-dialog__header-icon" color="white" size="22">mdi-bank-transfer-out</v-icon>
          <span class="rv-selection-dialog__header-title">Export Selected Clients Bank Details</span>
        </div>

        <div class="rv-selection-dialog__body">
          <p class="rv-selection-dialog__desc">
            Once you click confirm, you can export selected clients bank details
            and the Finance Refund to Client date will be updated for the selected clients.
          </p>

          <v-form lazy-validation>
            <v-container class="pa-0">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="rv-datepicker">
                        <v-icon size="18" color="var(--app-text-muted)" class="rv-datepicker__icon">mdi-calendar</v-icon>
                        <input
                          type="text"
                          class="rv-datepicker__input"
                          :value="apSelectedDate"
                          readonly
                          placeholder="Select date"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </div>
                    </template>
                    <v-date-picker
                      v-model="apSelectedDate"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </v-container>
          </v-form>
        </div>

        <div class="rv-selection-dialog__actions">
          <button
            class="rv-selection-dialog__btn rv-selection-dialog__btn--cancel"
            @click="toggleSelectionDialog(false)"
          >
            Cancel
          </button>
          <button
            class="rv-selection-dialog__btn rv-selection-dialog__btn--confirm"
            @click="showRefundClientForm()"
          >
            Confirm
          </button>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/objects/api";
import { mapState } from "vuex";
import Service from "@/objects/service";
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc/objects/globalData";

export default {
  mixins: [hrdcFunction],
  name: "ApApplicationSelection",
  data: () => ({
    api: new Api(),
    service: new Service(),
    isLoading: false,
    apSelectedDate: new Date(
      Date.now() - new Date().getTimezoneOffset() * 60000
    )
      .toISOString()
      .substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    hrdcData: new HrdcData(),
    actionItems: [
      {
        title: "Refund Client",
        clickFunc: "toggleSelectionDialog",
        icon: "mdi-bank-transfer-out",
      },
      {
        title: "Download Excel",
        clickFunc: "downloadExcel",
        icon: "mdi-file-download-outline",
      },
      {
        title: "Previous Record",
        clickFunc: "prevRecord",
        icon: "mdi-history",
      },
    ],
  }),
  computed: mapState({
    auth: (state) => state.auth.data,
    services: (state) => state.service.data.services,
  }),
  props: {
    apApplicationSelectionDialog: {
      type: Boolean,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
  },
  methods: {
    showRefundClientForm() {
      var selectedDate = this.apSelectedDate;
      this.$emit("showRefundClientForm", selectedDate);
    },
    toggleSelectionDialog(value) {
      this.$emit("toggleSelectionDialog", value);
    },
    triggerAction(value) {
      switch (value) {
        case "toggleSelectionDialog":
          this.$emit("toggleSelectionDialog", true);
          break;
        case "downloadExcel":
          this.$emit("downloadExcel");
          break;
        case "prevRecord":
          this.$emit("prevRecord");
          break;
      }
    },
  },
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .rv-actions-menu__item:hover {
  background-color: var(--app-accent-soft) !important;
}

.dark-mode .rv-actions-menu__icon {
  color: var(--app-text-muted) !important;
}

.dark-mode .rv-actions-menu__title {
  color: var(--app-text) !important;
}

.dark-mode .rv-selection-dialog__desc {
  color: var(--app-text-muted);
}

.dark-mode .rv-datepicker {
  background: var(--app-card);
  border: 1.5px solid var(--app-border);
}

.dark-mode .rv-datepicker__input {
  color: var(--app-text);
}

.dark-mode .rv-selection-dialog__btn--cancel {
  background: var(--app-card);
  border: 1.5px solid var(--app-border-strong);
}

.dark-mode .rv-selection-dialog__btn--cancel:hover {
  background: var(--app-surface);
}

/* >>> end auto-dark <<< */

/* Actions button */
.rv-actions-btn {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.85rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  border-radius: 10px !important;
  padding: 0 16px !important;
  height: 38px !important;
  background: #56bde8 !important;
  box-shadow: 0 2px 8px rgba(86, 189, 232, 0.25) !important;
  transition: all 0.15s ease !important;
}

.rv-actions-btn:hover {
  background: #3dadd8 !important;
  box-shadow: 0 4px 12px rgba(86, 189, 232, 0.35) !important;
}

/* Actions dropdown menu */
.rv-actions-menu {
  border-radius: 12px !important;
  padding: 6px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
}

.rv-actions-menu__item {
  border-radius: 8px !important;
  min-height: 40px !important;
  padding: 0 12px !important;
  transition: background-color 0.15s ease;
}

.rv-actions-menu__item:hover {
  background-color: #f0f9ff !important;
}

.rv-actions-menu__icon {
  color: #64748b !important;
  font-size: 18px !important;
}

.rv-actions-menu__title {
  font-family: 'Lato', sans-serif !important;
  font-size: 0.85rem !important;
  font-weight: 500 !important;
  color: #334155 !important;
}

/* Selection dialog */
.rv-selection-dialog__card {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
}

.rv-selection-dialog__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 24px;
  background: #56bde8;
}

.rv-selection-dialog__header-icon {
  flex-shrink: 0;
}

.rv-selection-dialog__header-title {
  font-family: 'Lato', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
}

.rv-selection-dialog__body {
  padding: 24px;
}

.rv-selection-dialog__desc {
  font-family: 'Lato', sans-serif;
  font-size: 0.88rem;
  color: #64748b;
  line-height: 1.6;
  margin: 0 0 20px;
}

/* Date picker trigger */
.rv-datepicker {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 14px;
  transition: border-color 0.15s ease;
  cursor: pointer;
}

.rv-datepicker:hover {
  border-color: #56bde8;
}

.rv-datepicker__icon {
  flex-shrink: 0;
}

.rv-datepicker__input {
  flex: 1;
  border: none;
  outline: none;
  font-family: 'Lato', sans-serif;
  font-size: 0.9rem;
  color: #334155;
  background: transparent;
  cursor: pointer;
}

/* Dialog actions */
.rv-selection-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 0 24px 20px;
}

.rv-selection-dialog__btn {
  padding: 10px 28px;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;
}

.rv-selection-dialog__btn--cancel {
  background: #fff;
  color: #0ea5e9;
  border: 1.5px solid #d1d5db;
}

.rv-selection-dialog__btn--cancel:hover {
  background: #f8fafc;
  border-color: #0ea5e9;
}

.rv-selection-dialog__btn--confirm {
  background: #56bde8;
  color: #fff;
  border: none;
}

.rv-selection-dialog__btn--confirm:hover {
  background: #3dadd8;
  box-shadow: 0 4px 12px rgba(86, 189, 232, 0.3);
}

@media (max-width: 599px) {
  .rv-selection-dialog__header {
    padding: 14px 18px;
  }

  .rv-selection-dialog__body {
    padding: 16px;
  }

  .rv-selection-dialog__desc {
    font-size: 0.78rem;
  }

  .rv-selection-dialog__actions {
    padding: 0 16px 16px;
    flex-wrap: wrap;
  }

  .rv-selection-dialog__btn {
    flex: 1;
    text-align: center;
    justify-content: center;
    padding: 10px 16px;
    font-size: 0.82rem;
  }
}
</style>
